/**
 * File: tecthubPage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v4.0.1
 * Created: 2025-12-04
 * Last Updated: 2026-02-18
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Images
import uiDashboard from "../../assets/images/ui-dashboard.svg";
import uiHero from "../../assets/images/ui-hero.jpg";

// Icons
import { FaLock } from "react-icons/fa6";
import { FaRegCalendarCheck } from "react-icons/fa6";
import { FaShieldHalved } from "react-icons/fa6";
import { MdMarkEmailRead } from "react-icons/md";

// Tecthub Page
export const tecthubPage = {
    meta: {
        id: "tecthub-page",
    },
    hero: {
        image: uiHero,
        headline: "Instantly Scale Your Engineering Team",
        subheadline:
            "Add qualified drafters, designers, engineers, and QAQC experts on demand",
        primaryButton: {
            text: "Get Started",
            type: "primary",
        },
        secondaryButton: {
            text: "Send Inquiry",
            type: "secondary",
        },
    },
    planCard: {
        title: "Pay As You Go Pricing",
        plans: [
            {
                id: "plan-ps-1",
                header: "Surveying",
                cost: 1500,
                currency: "USD",
                model: "/visit",
            },
            {
                id: "plan-ps-2",
                header: "Drafter",
                cost: 75,
                currency: "USD",
                model: "/hour",
            },
            {
                id: "plan-ps-3",
                header: "Engineer",
                cost: 100,
                currency: "USD",
                model: "/hour",
            },
            {
                id: "plan-ps-4",
                header: "QAQC Review",
                cost: 125,
                currency: "USD",
                model: "/hour",
            },
        ],
        features: [
            {
                id: "feature-ps-1",
                icon: <FaRegCalendarCheck />,
                text: "30-Day Money-Back Guarantee",
            },
            {
                id: "feature-ps-2",
                icon: <MdMarkEmailRead />,
                text: "Priority Email Support",
            },
            {
                id: "feature-ps-3",
                icon: <FaShieldHalved />,
                text: "Enterprise-grade Security",
            },
            {
                id: "feature-ps-4",
                icon: <FaLock />,
                text: "100% Data Privacy",
            },
        ],
    },
    articles: [
        {
            id: "article-ps-1",
            reverse: false,
            image: uiDashboard,
            headline: "On-Demand Project Support",
            description:
                "Easily bring in vetted professionals to support your projects. Whether you need drafting, design, engineering, or QAQC help, scale up your capacity in hours, not weeks.",
        },
        {
            id: "article-ps-2",
            reverse: true,
            image: uiDashboard,
            headline: "Flexible Resourcing Without the Hassle",
            description:
                "No hiring delays or long-term commitments. Tap into a trusted network of skilled professionals ready to plug into your workflow, exactly when and where you need them.",
        },
        {
            id: "article-ps-3",
            reverse: false,
            image: uiDashboard,
            headline: "Keep Projects Moving, Even Under Pressure",
            description:
                "Avoid bottlenecks and missed deadlines. Support your in-house team with expert reinforcements to stay on schedule and deliver high-quality work at scale.",
        },
    ],
    faq: [
        {
            id: "faq-ps-1",
            header: "What is Tecthub and how does it work?",
            content:
                "Tecthub is an on-demand resourcing platform that connects you with qualified drafters, designers, engineers, and QAQC professionals. After submitting a work order, our team assigns the appropriate expert (typically within 24–48 hours) who then completes the task and returns deliverables directly to your team.",
        },
        {
            id: "faq-ps-2",
            header: "Who is Tecthub designed for?",
            content:
                "Tecthub is built for engineering firms, owners, and project teams who need fast, reliable support without the delays and overhead of traditional hiring. It’s ideal for teams experiencing workload spikes, staffing gaps, or tight deadlines.",
        },
        {
            id: "faq-ps-3",
            header: "How quickly can work start after submitting a request?",
            content:
                "Work orders are typically assigned to a vetted professional within 24–48 hours. Once assigned, the team member begins work immediately based on project priority and available information.",
        },
        {
            id: "faq-ps-4",
            header: "What is the typical turnaround time for outsourced work?",
            content:
                "Depending on scope and complexity, most tasks are completed within approximately three business days. Larger or multi-phase projects may require additional time, which will be communicated upfront.",
        },
        {
            id: "faq-ps-5",
            header: "What information is required to start a service request?",
            content:
                "Each service type includes a guided submission workflow. You may be asked to upload plans, models, markups, project notes, scope descriptions, or other essential files so our team can start work efficiently and accurately.",
        },
        {
            id: "faq-ps-6",
            header: "Do I need to sign a contract or commit to a minimum amount of work?",
            content:
                "No. Tecthub is fully pay-as-you-go. There are no long-term contracts, staffing commitments, or minimum usage requirements. You are only billed for the hours or services you request through your work orders.",
        },
        {
            id: "faq-ps-7",
            header: "How does Tecthub ensure quality and accuracy?",
            content:
                "All work is performed by vetted professionals and reviewed under the supervision of licensed engineers. We prioritize accuracy, code compliance, and consistency (never rushed or low-quality deliverables) so your team can rely on results every time.",
        },
    ],
    cta: {
        label: "Explore On-Demand Engineering Talent",
        headline: "Scale Smarter, Not Harder",
        description:
            "Support your team with reliable external help and never miss another deadline. Start building your flexible engineering bench today.",
    },
};
